(function($) {

    //
    // Articles list swiper
    //

    $('.article-swiper').each(function(index, elem) {

        var swiperOptions;
        var columnsCount = $(this).attr('data-columns');

        var nextBtn = $(this).find('.swiper-button-next')[0];
        var prevBtn = $(this).find('.swiper-button-prev')[0];

        if (columnsCount == 1) {
            swiperOptions = {
                loop: false,
                spaceBetween: 24,
                slidesPerView: 1.3,
                freeMode: true,
                breakpoints: {
                    1110: {
                        freeMode: false,
                        slidesPerView: 4,
                        navigation: {
                            nextEl: nextBtn,
                            prevEl: prevBtn,
                        }
                    },
                    800: {
                        freeMode: false,
                        slidesPerView: 3,
                        navigation: {
                            nextEl: nextBtn,
                            prevEl: prevBtn,
                        }
                    },
                    650: {
                        freeMode: false,
                        slidesPerView: 2,
                        navigation: {
                            nextEl: nextBtn,
                            prevEl: prevBtn,
                        }
                    }
                }
            };
        }
        else if (columnsCount == 2) {
            swiperOptions = {
                loop: false,
                slidesPerView: 1.3,
                slidesPerColumnFill: 'row',
                slidesPerColumn: 2,
                freeMode: true,
                breakpoints: {
                    1110: {
                        freeMode: false,
                        slidesPerView: 4,
                        slidesPerColumnFill: 'row',
                        slidesPerColumn: 2,
                        navigation: {
                            nextEl: nextBtn,
                            prevEl: prevBtn,
                        }
                    },
                    800: {
                        freeMode: false,
                        slidesPerView: 3,
                        slidesPerColumnFill: 'row',
                        slidesPerColumn: 2,
                        navigation: {
                            nextEl: nextBtn,
                            prevEl: prevBtn,
                        }
                    },
                    650: {
                        freeMode: false,
                        slidesPerView: 2,
                        slidesPerColumnFill: 'row',
                        slidesPerColumn: 2,
                        navigation: {
                            nextEl: nextBtn,
                            prevEl: prevBtn,
                        }
                    }
                }
            };
        }

        var articleSwiper = new Swiper($(this)[0], swiperOptions);
    });

    //
    // Instagram feed swiper
    //

    var instagramSwiper = new Swiper('.instagram-swiper', {
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        loop: false,
        freeMode: true,
        slidesPerView: 'auto',
        slidesPerColumn: 2,
        slidesPerColumnFill: 'column',

        on: {
            fromEdge: function (e) {
                if ($(this)[0].$el.find('.swiper-button-prev').hasClass('swiper-button-disabled')) {
                    e.$el[0].classList.remove('hide-left');
                } else if ($(this)[0].$el.find('.swiper-button-next').hasClass('swiper-button-disabled')) {
                    e.$el[0].classList.remove('hide-right');
                }
            },
            toEdge: function(e) {
                if (e.isEnd) {
                    e.$el[0].classList.add('hide-right');
                } else if (e.isBeginning) {
                    e.$el[0].classList.add('hide-left');
                }
            }
        }
    });

})( jQuery );